import React from "react";
import "../../styles/estudarUA.css";
import { LinkBTNImg } from "../LinkBTN";
/* 1 LINK */
import Paco from "../../imgs/Icons/paco.svg";
/* 6 LINK */
import MoneyBag from "../../imgs/Icons/money_bag.svg";
import Home from "../../imgs/Icons/home.svg";
import Restaurant from "../../imgs/Icons/restaurant.svg";
import Run from "../../imgs/Icons/run.svg";
import Heart from "../../imgs/Icons/heart.svg";
import Study from "../../imgs/Icons/study.svg";
/* 8 LINK */
import Servicedesk from "../../imgs/Icons/servicedesk.svg";
import User_uni from "../../imgs/Icons/user_uni.svg";
import Email from "../../imgs/Icons/email.svg";
import Wifi from "../../imgs/Icons/wifi.svg";
import Elearning from "../../imgs/Icons/elearning.svg";
import UAmobile from "../../imgs/Icons/ua_mobile.svg";
import VPN from "../../imgs/Icons/vpn.svg";
import MyUA from "../../imgs/Icons/my_ua.svg";

import { withNamespaces } from 'react-i18next';


const EstudarUA = ({ t }) => {


  return (
    <>
      <div className="container">
        {/* AREA 1 SOBRE A UA */}
        <div id="1" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3">
            <h2>{t('moduleEstudarUA:S1.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8">
            <p className="p_next">
              {t('moduleEstudarUA:S1.P1')}
            </p>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleEstudarUA:S1.P2') }}>
            </p>
            <iframe
              src="https://www.youtube.com/embed/QbIDx8Hbif0"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="next"
              title={t('moduleEstudarUA:S1.Title')}
            ></iframe>
            <p className="p_next">
              {t('moduleEstudarUA:S1.P3')}
            </p>
          </div>
        </div>
        {/* AREA 2 INFO ACADÉMICAS COMPLEMENTARES */}
        <div id="2" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3">
            <h2>{t('moduleEstudarUA:S2.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8">
            <div id="frequencia_assiduidade" className="fantasmaAncora"></div>
            <h3>{t('moduleEstudarUA:S2.ST1.ST')}</h3>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleEstudarUA:S2.ST1.P1') }}>
            </p>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleEstudarUA:S2.ST1.P2') }}>
            </p>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleEstudarUA:S2.ST1.P3') }}>
            </p>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleEstudarUA:S2.ST1.P4') }}>
            </p>
            <p className="p_next">
              <span
                dangerouslySetInnerHTML={{ __html: t('moduleEstudarUA:S2.ST1.P5.P1') }}>
              </span>
              <a className='link' target='_blank' rel='noreferrer' href={t('moduleEstudarUA:S2.ST1.P5.Link1')} title={t('moduleEstudarUA:S2.ST1.P5.Title1')}>
                {t('moduleEstudarUA:S2.ST1.P5.P2')}
              </a>
              {t('moduleEstudarUA:S2.ST1.P5.P3')}
              <a className='link' target='_blank' rel='noreferrer' href={t('moduleEstudarUA:S2.ST1.P5.Link2')} title={t('moduleEstudarUA:S2.ST1.P5.Title2')}>
                {t('moduleEstudarUA:S2.ST1.P5.P4')}
              </a>
              {t('moduleEstudarUA:S2.ST1.P5.P5')}
            </p>
            <div id="creditos_ects" className="fantasmaAncora"></div>
            <h3>{t('moduleEstudarUA:S2.ST2.ST')}</h3>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleEstudarUA:S2.ST2.P1') }}>
            </p>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleEstudarUA:S2.ST2.P2') }}>
            </p>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleEstudarUA:S2.ST2.P3') }}>
            </p>
            <p className="p_next">
              {t('moduleEstudarUA:S2.ST2.P4.P1')}
              <a className='link' target='_blank' rel='noreferrer' href={t('moduleEstudarUA:S2.ST2.P4.Link')} title={t('moduleEstudarUA:S2.ST2.P4.Title')}>{t('moduleEstudarUA:S2.ST2.P4.P2')}</a>{t('moduleEstudarUA:S2.ST2.P4.P3')}
            </p>
            <div id="avalicao" className="fantasmaAncora"></div>
            <h3>{t('moduleEstudarUA:S2.ST3.ST')}</h3>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleEstudarUA:S2.ST3.P1') }}>
            </p>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleEstudarUA:S2.ST3.P2') }}>
            </p>
            <p className="p_next">
              {t('moduleEstudarUA:S2.ST3.P3')}
            </p>
            <div id="aproveitamento_escolar" className="fantasmaAncora"></div>
            <h3>{t('moduleEstudarUA:S2.ST4.ST')}</h3>
            <p className="p_next">
              <span dangerouslySetInnerHTML={{ __html: t('moduleEstudarUA:S2.ST4.P1.P1') }}></span>
              <a className='link' target='_blank' rel='noreferrer' href={t('moduleEstudarUA:S2.ST4.P1.Link')} title={t('moduleEstudarUA:S2.ST4.P1.Title')}>{t('moduleEstudarUA:S2.ST4.P1.P2')}</a>{t('moduleEstudarUA:S2.ST4.P1.P3')}
            </p>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleEstudarUA:S2.ST4.P2') }}>
            </p>
            <div id="epoca_exames" className="fantasmaAncora"></div>
            <h3>{t('moduleEstudarUA:S2.ST5.ST')}</h3>
            <p className="p_next">
              <span dangerouslySetInnerHTML={{ __html: t('moduleEstudarUA:S2.ST5.P.P1') }}></span>
              <a className='link' target='_blank' rel='noreferrer' href={t('moduleEstudarUA:S2.ST5.P.Link')} title={t('moduleEstudarUA:S2.ST5.P.Title')}>{t('moduleEstudarUA:S2.ST5.P.P2')}</a>{t('moduleEstudarUA:S2.ST5.P.P3')}
            </p>
          </div>
        </div>
        {/* AREA 3 SERVIÇOS DE APOIO*/}
        <div id="3" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3">
            <h2>{t('moduleEstudarUA:S3.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8">
            <div id="serviços_gestao" className="fantasma_space fantasmaAncora"></div>
            <h3>{t('moduleEstudarUA:S3.ST1.ST')}</h3>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleEstudarUA:S3.ST1.P1') }}>
            </p>
            <p className="p_next">
              {t('moduleEstudarUA:S3.ST1.P2')}
            </p>
            {/* 1 LINK */}
            <LinkBTNImg
              link={t('moduleEstudarUA:S3.ST1.BTN.Link')}
              icon={Paco}
              iconAlt={t('moduleEstudarUA:S3.ST1.BTN.iconAlt')}
              btnName={t('moduleEstudarUA:S3.ST1.BTN.btnName')}
            />
            <div id="servicos_acao" className="fantasmaAncora"></div>
            <h3 className="mt-4">{t('moduleEstudarUA:S3.ST2.ST')}</h3>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleEstudarUA:S3.ST2.P1') }}>
            </p>
            {/* 6 LINK */}
            <LinkBTNImg
              link={t('moduleEstudarUA:S3.ST2.BTN1.Link')}
              icon={MoneyBag}
              iconAlt={t('moduleEstudarUA:S3.ST2.BTN1.iconAlt')}
              btnName={t('moduleEstudarUA:S3.ST2.BTN1.btnName')}
            />
            <LinkBTNImg
              link={t('moduleEstudarUA:S3.ST2.BTN2.Link')}
              icon={Home}
              iconAlt={t('moduleEstudarUA:S3.ST2.BTN2.iconAlt')}
              btnName={t('moduleEstudarUA:S3.ST2.BTN2.btnName')}
            />
            <LinkBTNImg
              link={t('moduleEstudarUA:S3.ST2.BTN3.Link')}
              icon={Restaurant}
              iconAlt={t('moduleEstudarUA:S3.ST2.BTN3.iconAlt')}
              btnName={t('moduleEstudarUA:S3.ST2.BTN3.btnName')}
            />
            <LinkBTNImg
              link={t('moduleEstudarUA:S3.ST2.BTN4.Link')}
              icon={Run}
              iconAlt={t('moduleEstudarUA:S3.ST2.BTN4.iconAlt')}
              btnName={t('moduleEstudarUA:S3.ST2.BTN4.btnName')}
            />
            <LinkBTNImg
              link={t('moduleEstudarUA:S3.ST2.BTN5.Link')}
              icon={Heart}
              iconAlt={t('moduleEstudarUA:S3.ST2.BTN5.iconAlt')}
              btnName={t('moduleEstudarUA:S3.ST2.BTN5.btnName')}
            />
            <LinkBTNImg
              link={t('moduleEstudarUA:S3.ST2.BTN6.Link')}
              icon={Study}
              iconAlt={t('moduleEstudarUA:S3.ST2.BTN6.iconAlt')}
              btnName={t('moduleEstudarUA:S3.ST2.BTN6.btnName')}
            />
            <div id="servicos_tecnologias" className="fantasmaAncora"></div>
            <h3 className="mt-4">
              {t('moduleEstudarUA:S3.ST3.ST')}
            </h3>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleEstudarUA:S3.ST3.P1') }}>
            </p>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleEstudarUA:S3.ST3.P2') }}>
            </p>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleEstudarUA:S3.ST3.P3') }}>
            </p>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleEstudarUA:S3.ST3.P4') }}>
            </p>
            {/* 8 LINK */}
            <LinkBTNImg
              link={t('moduleEstudarUA:S3.ST3.BTN1.Link')}
              icon={Servicedesk}
              iconAlt={t('moduleEstudarUA:S3.ST3.BTN1.iconAlt')}
              btnName={t('moduleEstudarUA:S3.ST3.BTN1.btnName')}
            />
            <LinkBTNImg
              link={t('moduleEstudarUA:S3.ST3.BTN2.Link')}
              icon={User_uni}
              iconAlt={t('moduleEstudarUA:S3.ST3.BTN2.iconAlt')}
              btnName={t('moduleEstudarUA:S3.ST3.BTN2.btnName')}
            />
            <LinkBTNImg
              link={t('moduleEstudarUA:S3.ST3.BTN3.Link')}
              icon={Email}
              iconAlt={t('moduleEstudarUA:S3.ST3.BTN3.iconAlt')}
              btnName={t('moduleEstudarUA:S3.ST3.BTN3.btnName')}
            />
            <LinkBTNImg
              link={t('moduleEstudarUA:S3.ST3.BTN4.Link')}
              icon={Wifi}
              iconAlt={t('moduleEstudarUA:S3.ST3.BTN4.iconAlt')}
              btnName={t('moduleEstudarUA:S3.ST3.BTN4.btnName')}
            />
            <LinkBTNImg
              link={t('moduleEstudarUA:S3.ST3.BTN5.Link')}
              icon={Elearning}
              iconAlt={t('moduleEstudarUA:S3.ST3.BTN5.iconAlt')}
              btnName={t('moduleEstudarUA:S3.ST3.BTN5.btnName')}
            />
            <LinkBTNImg
              link={t('moduleEstudarUA:S3.ST3.BTN6.Link')}
              icon={UAmobile}
              iconAlt={t('moduleEstudarUA:S3.ST3.BTN6.iconAlt')}
              btnName={t('moduleEstudarUA:S3.ST3.BTN6.btnName')}
            />
            <LinkBTNImg
              link={t('moduleEstudarUA:S3.ST3.BTN7.Link')}
              icon={VPN}
              iconAlt={t('moduleEstudarUA:S3.ST3.BTN7.iconAlt')}
              btnName={t('moduleEstudarUA:S3.ST3.BTN7.btnName')}
            />
            <LinkBTNImg
              link={t('moduleEstudarUA:S3.ST3.BTN8.Link')}
              icon={MyUA}
              iconAlt={t('moduleEstudarUA:S3.ST3.BTN8.iconAlt')}
              btnName={t('moduleEstudarUA:S3.ST3.BTN8.btnName')}
            />
            <div id="bibliotecas_info" className="fantasmaAncora"></div>
            <h3 className="mt-4">
              {t('moduleEstudarUA:S3.ST4.ST')}
            </h3>
            <p className="p_next">
              {t('moduleEstudarUA:S3.ST4.P1')}
            </p>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleEstudarUA:S3.ST4.P2') }}>
            </p>
            <p className="p_next">
              {t('moduleEstudarUA:S3.ST4.P3.P1')}
              <a className='link' target='_blank' rel='noreferrer' href={t('moduleEstudarUA:S3.ST4.P3.Link1')} title={t('moduleEstudarUA:S3.ST4.P3.Title1')}>{t('moduleEstudarUA:S3.ST4.P3.Link1')}</a> {t('moduleEstudarUA:S3.ST4.P3.P2')}<a className='link' target='_blank' rel='noreferrer' href={t('moduleEstudarUA:S3.ST4.P3.Link2')} title={t('moduleEstudarUA:S3.ST4.P3.Title2')}>{t('moduleEstudarUA:S3.ST4.P3.Link2')}</a>{t('moduleEstudarUA:S3.ST4.P3.P3')}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces()(EstudarUA);
